import {
  SIDEBAR_SEARCH_CONTENT,
  CLEAR_SIDEBAR_SEARCH_CONTENT
} from 'actions/Types';

/**
 * For now we store the search term in state
 * Until properly scoped
 */

const initialState = {
  isLoading: false,
  content: {},
  searchTerm: ''
};

export default (state = initialState, action) => {
  if (action.type === SIDEBAR_SEARCH_CONTENT) {
    const { searchTerm } = action.payload;
    return { ...state, searchTerm };
  }

  if (action.type === CLEAR_SIDEBAR_SEARCH_CONTENT)
    return { ...initialState, searchTerm: '' };

  return state;
};
